module.exports = __webpack_public_path__ + "static/media/logo_150px.f9bc8c46.png";